import {
    BounceZoomIn,
    BounceZoomOut,
    FadeIn,
    FadeOut,
    PivotBounceZoomOut
} from "slotworks/graphics/animation/base-animations";
import Layers from "slotworks/graphics/layers/layers";
import RevolverWinTransitions from "slotworks/integration/revolver/transitions/revolver-win-transitions";
import SoundManager from "slotworks/sound/sound-manager";
import Contract from "slotworks/utils/contract";
import Point from "slotworks/utils/geom/point";
import { parallel, sequence } from "slotworks/utils/race-utils";
import Timer from "slotworks/utils/timer";
import * as TweenJS from "slotworks/utils/tween";
import Components from "../../../components/components";
import { CenterPivot } from "../../../graphics/pixi/group";

export default class BigWinTransitions extends RevolverWinTransitions {
    public EXPLOSION_TIME: number = 4000;
    public TEXT_ZOOM = 1.1;

    private big: PIXI.Sprite;

    public in(): Contract<void> {
        return new Contract((resolve) => {
            this.resetEverything();

            this.big = Layers.CelebrationContent.getSprite("big");

            this.big.visible = false;
            RevolverWinTransitions.winText.visible = false;
            RevolverWinTransitions.winValue.visible = false;

            this.inResolve = resolve;

            this.explode();

            this.timers = [];

            FadeIn(RevolverWinTransitions.background, this.BOUNCE_TIME * 0.5).execute();

            this.zoomTextIn(this.TEXT_ZOOM, this.EXPLOSION_TIME).execute();

            SoundManager.customEvent("big_win");

            this.timers.push(Timer.setTimeout(() => {
                this.explodeAgain();
            }, this.EXPLOSION_TIME - this.EXPLOSION_OFFSET));

            this.timers.push(Timer.setTimeout(() => {
                this.big.visible = true;
                RevolverWinTransitions.winText.visible = true;
                RevolverWinTransitions.winValue.visible = true;

                parallel([
                    () => this.introduce(RevolverWinTransitions.winText, this.BOUNCE_TIME, new Point(0.5, 1)),
                    () => this.introduce(this.big, this.BOUNCE_TIME, new Point(0.5, 1)),
                    () => BounceZoomIn(RevolverWinTransitions.winValue, this.BOUNCE_TIME)
                ]).then(() => {
                    this.endlessHover(this.big);

                    this.resolveIn();
                });

            }, this.EXPLODE_DELAY));
        });
    }

    public skipIn() {
        this.clearTimers();
        RevolverWinTransitions.blastLeft.emit = false;
        RevolverWinTransitions.blastRight.emit = false;
        RevolverWinTransitions.explodeEmitter.emit = false;

        this.endlessHover(this.big);

        this.big.visible = true;
        RevolverWinTransitions.winText.visible = true;
        RevolverWinTransitions.winValue.visible = true;

        SoundManager.customEvent("big_win");
        this.setTextSize(this.TEXT_ZOOM);
        this.resolveIn();
    }

    public out(): Contract<void> {
        return sequence([
            () => Contract.wrap(() => {
                TweenJS.removeAll(RevolverWinTransitions.winValue.scale);
            }),
            () => this.groupAndAnimateOut(this.big),
            () => Contract.wrap(() => {
                this.clearTimers();
                this.big.visible = false;
                RevolverWinTransitions.winText.visible = false;
                SoundManager.customEvent("celebration_end");
            }),
            () => FadeOut(RevolverWinTransitions.background, this.BOUNCE_TIME * 0.5),
            () => Contract.wrap(() => {
                RevolverWinTransitions.coinShower.emit = false;
            }),
            () => Contract.getTimeoutContract(750),
            () => Contract.wrap(() => {
                this.resetEmitter(RevolverWinTransitions.coinShower);
                TweenJS.removeAll(RevolverWinTransitions.winText);
                TweenJS.removeAll(RevolverWinTransitions.winText.scale);
            })
        ]);
    }

    public destroy() {
        this.clearTimers();
        TweenJS.removeAll(this.big.scale);
        TweenJS.removeAll(this.big);

        super.destroy();
    }

    private resetEverything() {
        if (RevolverWinTransitions.coinShower) {
            this.resetEmitter(RevolverWinTransitions.coinShower);
            this.resetEmitter(RevolverWinTransitions.gemShower);
            this.resetEmitter(RevolverWinTransitions.explodeEmitter);
            this.resetEmitter(RevolverWinTransitions.blastLeft);
            this.resetEmitter(RevolverWinTransitions.blastRight);
        }

        RevolverWinTransitions.coinShower = Layers.CelebrationBackground.getParticle("coinShower");
        RevolverWinTransitions.gemShower = Layers.CelebrationBackground.getParticle("gemShower");

        RevolverWinTransitions.coinShower.parent.y -= 100;
        RevolverWinTransitions.gemShower.parent.y -= 100;

        RevolverWinTransitions.explodeEmitter = Layers.CelebrationForeground.getParticle("coinExplode");
        RevolverWinTransitions.blastLeft = Layers.CelebrationForeground.getParticle("coinBlastLeft");
        RevolverWinTransitions.blastRight = Layers.CelebrationForeground.getParticle("coinBlastRight");

        RevolverWinTransitions.blastLeft.emit = false;
        RevolverWinTransitions.blastRight.emit = false;
        RevolverWinTransitions.explodeEmitter.emit = false;

        RevolverWinTransitions.background = Layers.CelebrationBackground.getSprite("winrect");
        RevolverWinTransitions.winValue = Layers.CelebrationForeground.getBitmapText("value");
        RevolverWinTransitions.winText = Layers.CelebrationForeground.getSprite("win");
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/transitions/big-win-transitions.ts